import { Box } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { Show, SimpleShowLayout } from "react-admin";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import { SectionTitle } from "features/SectionTitle";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import SelectionProtocolDialog from "./components/SelectionProtocolDialog";
import InfoSection from "./InfoSection";
import CommissionSection from "./CommissionSection";
import UniversitiesSection from "./UniversitiesSection";

const ShowCampaignForOutgoingStudents = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const shadow = isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox;

  return (
    <Show
      title="Детайли за кампания"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canManageErasmusCampaigns}>
              <SelectionProtocolDialog />
            </SecuredComponent>
          }
        />
      }
    >
      <SimpleShowLayout>
        <SectionTitle
          paddingY={2}
          title="Основна информация"
          textAlign="center"
        />
        <Box sx={shadow}>
          <InfoSection />
        </Box>

        <SectionTitle
          paddingY={2}
          title="Комисия"
          textAlign="center"
        />
        <Box sx={shadow}>
          <CommissionSection />
        </Box>

        <SectionTitle
          paddingY={2}
          title="Университети"
          textAlign="center"
        />
        <Box sx={shadow}>
          <UniversitiesSection />
        </Box>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowCampaignForOutgoingStudents;
